import React, { Component } from 'react';
import { get } from 'lodash';
import Column from './Column';

class HighlightRow extends Component {
    _open = () => this.props.onOpen(this.props.item);
    render() {
        const extraClass = this.props.highlightFunction ? this.props.highlightFunction(this.props.item) : '';
        return (
            <tr className={`ckp-tables-body-row ${extraClass} is-clickable is-white`}>
                <td className="ckp-tables-rest-column" onClick={this._open}>
                    {this.props.fields.map(f => (
                        <Column
                            disableTooltip={this.props.disableTooltip}
                            key={f.key}
                            value={get(this.props.item, f.key)}
                            parentItem={this.props.item}
                            isSmall={this.props.smallColumns.includes(f.key)}
                            isLarge={this.props.largeColumns.includes(f.key)}
                            transformFunction={this.props.transformFunctions[f.key]}
                        />
                    ))}
                </td>
            </tr>
        );
    }
}

HighlightRow.defaultProps = { transformFunctions: {}, smallColumns: [], largeColumns: [] };

export default HighlightRow;
